import { Injectable } from '@angular/core';
import { EncryptStorage } from 'encrypt-storage';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class StorageService extends EncryptStorage {
    constructor() {
        super(environment.secretKey, {
            prefix: 'aajeevika',
            storageType: 'localStorage',
            encAlgorithm: 'AES',
            doNotEncryptValues: false
        });
    }
}
